module.exports = __webpack_public_path__ + "static/media/dusting.db9e784a.png";